// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 个人中心页优化 */
.profile-page { min-height:100vh; background:var(--color-bg); }

.user-info-card { border-radius:28px; margin:22px 0 26px; padding:30px 26px; position:relative; overflow:hidden; }
.user-info-card::before { content:""; position:absolute; inset:0; background:radial-gradient(circle at 92% 15%,rgba(99,102,241,.2),rgba(255,255,255,0)); pointer-events:none; }
.user-avatar { font-size:52px; margin-right:22px; width:68px; height:68px; display:flex; align-items:center; justify-content:center; background:linear-gradient(145deg,#f2f4f8,#ffffff); color:var(--color-primary); border-radius:50%; box-shadow:inset 0 1px 0 rgba(255,255,255,.6),0 4px 10px -4px rgba(0,0,0,.2); }
.user-details h2 { margin:0 0 6px; font-size:1.2rem; font-weight:700; letter-spacing:.3px; color:var(--color-text); }
.user-details p { margin:4px 0; color:var(--color-text-sec); font-size:.8rem; }
.edit-btn { padding:10px 18px; border-radius:14px; font-size:.8rem; font-weight:600; }

.menu-section { margin:24px 0 10px; }
.menu-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; letter-spacing:.4px; font-weight:700; }
.menu-list { border-radius:26px; overflow:hidden; }
.menu-item { display:flex; justify-content:space-between; align-items:center; padding:18px 22px; border-bottom:1px solid var(--color-border); cursor:pointer; position:relative; transition:var(--transition-base); }
.menu-item:last-child { border-bottom:none; }
.menu-item::after { content:""; position:absolute; inset:0; background:linear-gradient(120deg,rgba(99,102,241,.08),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); }
.menu-item:hover { transform:translateY(-2px); box-shadow:0 4px 14px -6px rgba(0,0,0,.18); }
.menu-item:hover::after { opacity:1; }
.arrow { color:var(--color-muted); font-size:1rem; }

.orders-section { margin:30px 0 10px; }
.orders-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; font-weight:700; }
.orders-list { border-radius:26px; padding:10px 4px 4px; }
.order-item { display:flex; justify-content:space-between; align-items:center; padding:16px 18px 14px; border-bottom:1px solid var(--color-border); }
.order-item:last-child { border-bottom:none; }
.order-info h4 { margin:0 0 6px; font-size:.95rem; font-weight:600; letter-spacing:.4px; color:var(--color-text); }
.order-info p { margin:2px 0; font-size:.7rem; color:var(--color-text-sec); letter-spacing:.3px; }
.order-price { color:var(--color-danger)!important; font-weight:700; letter-spacing:.4px; }
.order-status { padding:6px 12px; border-radius:20px; font-size:.6rem; letter-spacing:1px; font-weight:700; text-transform:uppercase; box-shadow:0 2px 4px -2px rgba(0,0,0,.12); min-height:24px; display:flex; align-items:center; }
.status-pending { background:#fff7d6; color:#856404; }
.status-completed { background:#e6fbeb; color:#157347; }
.status-cancelled { background:#fde7ea; color:#b02a37; }

.view-all-orders { display:block; text-align:center; color:var(--color-primary); text-decoration:none; padding:12px 16px; background:var(--color-surface); border-radius:16px; font-size:.8rem; font-weight:600; border:1px solid var(--color-border); margin:6px 0 14px; transition:var(--transition-fast); }
.view-all-orders:hover { background:var(--color-surface-alt); }

@media (max-width: 640px) {
  .user-info-card {
    flex-direction: column;
    text-align: center;
    padding: 24px 20px;
  }

  .user-avatar { margin: 0 0 20px; }

  .edit-btn {
    margin-top: 12px;
    min-height: 44px;
    padding: 12px 20px;
  }

  .menu-item {
    padding: 18px 20px;
    min-height: 56px;
  }

  .order-item {
    padding: 16px 18px 14px;
  }
}

/* 小屏幕优化 (≤480px) */
@media (max-width: 480px) {
  .profile-page {
    padding-bottom: 20px; /* 移除底部导航栏空间，个人资料页面不显示导航栏 */
  }

  .user-info-card {
    padding: 20px 16px;
    margin: 16px 0 20px;
    border-radius: 20px;
  }

  .user-avatar {
    width: 60px;
    height: 60px;
    font-size: 48px;
  }

  .user-details h2 {
    font-size: 1.1rem;
  }

  .user-details p {
    font-size: 0.75rem;
  }

  .menu-section {
    margin: 20px 0 8px;
  }

  .menu-section h3 {
    font-size: 0.95rem;
    margin-bottom: 12px;
  }

  .menu-list {
    border-radius: 20px;
  }

  .menu-item {
    padding: 16px 18px;
    min-height: 52px;
  }

  .orders-section {
    margin: 24px 0 8px;
  }

  .orders-section h3 {
    font-size: 0.95rem;
  }

  .orders-list {
    border-radius: 20px;
    padding: 8px 2px 2px;
  }

  .order-item {
    padding: 14px 16px 12px;
  }

  .order-info h4 {
    font-size: 0.9rem;
  }

  .order-info p {
    font-size: 0.65rem;
  }

  .order-status {
    font-size: 0.55rem;
    padding: 4px 10px;
    min-height: 20px;
  }

  .view-all-orders {
    padding: 10px 14px;
    font-size: 0.75rem;
    border-radius: 14px;
  }
}

/* 超小屏幕优化 (≤360px) */
@media (max-width: 360px) {
  .user-info-card {
    padding: 18px 14px;
    margin: 14px 0 18px;
  }

  .user-avatar {
    width: 56px;
    height: 56px;
    font-size: 44px;
  }

  .user-details h2 {
    font-size: 1rem;
  }

  .user-details p {
    font-size: 0.7rem;
  }

  .edit-btn {
    padding: 10px 16px;
    font-size: 0.75rem;
    min-height: 40px;
  }

  .menu-item {
    padding: 14px 16px;
    min-height: 48px;
  }

  .order-item {
    padding: 12px 14px 10px;
  }

  .order-info h4 {
    font-size: 0.85rem;
  }

  .order-info p {
    font-size: 0.6rem;
  }

  .order-status {
    font-size: 0.5rem;
    padding: 3px 8px;
    min-height: 18px;
  }
}

/* 极小屏幕优化 (≤320px) */
@media (max-width: 320px) {
  .user-info-card {
    padding: 16px 12px;
  }

  .user-avatar {
    width: 52px;
    height: 52px;
    font-size: 40px;
  }

  .user-details h2 {
    font-size: 0.95rem;
  }

  .edit-btn {
    padding: 8px 14px;
    font-size: 0.7rem;
    min-height: 36px;
  }

  .menu-item {
    padding: 12px 14px;
    min-height: 44px;
  }

  .order-item {
    padding: 10px 12px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfilePage.css"],"names":[],"mappings":"AAAA,YAAY;AACZ,gBAAgB,gBAAgB,EAAE,0BAA0B,EAAE;;AAE9D,kBAAkB,kBAAkB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACjH,0BAA0B,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,qFAAqF,EAAE,mBAAmB,EAAE;AAC9K,eAAe,cAAc,EAAE,iBAAiB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kDAAkD,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,4EAA4E,EAAE;AACtT,mBAAmB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AACpH,kBAAkB,YAAY,EAAE,2BAA2B,EAAE,eAAe,EAAE;AAC9E,YAAY,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAErF,gBAAgB,kBAAkB,EAAE;AACpC,mBAAmB,uBAAuB,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACnH,aAAa,kBAAkB,EAAE,eAAe,EAAE;AAClD,aAAa,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,2CAA2C,EAAE,cAAc,EAAE,iBAAiB,EAAE,iCAAiC,EAAE;AACpN,wBAAwB,kBAAkB,EAAE;AAC5C,oBAAoB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,0EAA0E,EAAE,SAAS,EAAE,iCAAiC,EAAE;AACtL,mBAAmB,0BAA0B,EAAE,0CAA0C,EAAE;AAC3F,0BAA0B,SAAS,EAAE;AACrC,SAAS,wBAAwB,EAAE,cAAc,EAAE;;AAEnD,kBAAkB,kBAAkB,EAAE;AACtC,qBAAqB,uBAAuB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAChG,eAAe,kBAAkB,EAAE,oBAAoB,EAAE;AACzD,cAAc,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,2CAA2C,EAAE;AACpJ,yBAAyB,kBAAkB,EAAE;AAC7C,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAClH,gBAAgB,YAAY,EAAE,eAAe,EAAE,2BAA2B,EAAE,mBAAmB,EAAE;AACjG,eAAe,mCAAmC,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC1F,gBAAgB,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,wBAAwB,EAAE,yCAAyC,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACpO,kBAAkB,kBAAkB,EAAE,aAAa,EAAE;AACrD,oBAAoB,kBAAkB,EAAE,aAAa,EAAE;AACvD,oBAAoB,kBAAkB,EAAE,aAAa,EAAE;;AAEvD,mBAAmB,aAAa,EAAE,iBAAiB,EAAE,0BAA0B,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,iCAAiC,EAAE;AAC7S,yBAAyB,mCAAmC,EAAE;;AAE9D;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,eAAe,gBAAgB,EAAE;;EAEjC;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,oBAAoB,EAAE,2BAA2B;EACnD;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* 个人中心页优化 */\r\n.profile-page { min-height:100vh; background:var(--color-bg); }\r\n\r\n.user-info-card { border-radius:28px; margin:22px 0 26px; padding:30px 26px; position:relative; overflow:hidden; }\r\n.user-info-card::before { content:\"\"; position:absolute; inset:0; background:radial-gradient(circle at 92% 15%,rgba(99,102,241,.2),rgba(255,255,255,0)); pointer-events:none; }\r\n.user-avatar { font-size:52px; margin-right:22px; width:68px; height:68px; display:flex; align-items:center; justify-content:center; background:linear-gradient(145deg,#f2f4f8,#ffffff); color:var(--color-primary); border-radius:50%; box-shadow:inset 0 1px 0 rgba(255,255,255,.6),0 4px 10px -4px rgba(0,0,0,.2); }\r\n.user-details h2 { margin:0 0 6px; font-size:1.2rem; font-weight:700; letter-spacing:.3px; color:var(--color-text); }\r\n.user-details p { margin:4px 0; color:var(--color-text-sec); font-size:.8rem; }\r\n.edit-btn { padding:10px 18px; border-radius:14px; font-size:.8rem; font-weight:600; }\r\n\r\n.menu-section { margin:24px 0 10px; }\r\n.menu-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; letter-spacing:.4px; font-weight:700; }\r\n.menu-list { border-radius:26px; overflow:hidden; }\r\n.menu-item { display:flex; justify-content:space-between; align-items:center; padding:18px 22px; border-bottom:1px solid var(--color-border); cursor:pointer; position:relative; transition:var(--transition-base); }\r\n.menu-item:last-child { border-bottom:none; }\r\n.menu-item::after { content:\"\"; position:absolute; inset:0; background:linear-gradient(120deg,rgba(99,102,241,.08),rgba(99,102,241,0)); opacity:0; transition:var(--transition-base); }\r\n.menu-item:hover { transform:translateY(-2px); box-shadow:0 4px 14px -6px rgba(0,0,0,.18); }\r\n.menu-item:hover::after { opacity:1; }\r\n.arrow { color:var(--color-muted); font-size:1rem; }\r\n\r\n.orders-section { margin:30px 0 10px; }\r\n.orders-section h3 { color:var(--color-text); margin:0 0 14px; font-size:1rem; font-weight:700; }\r\n.orders-list { border-radius:26px; padding:10px 4px 4px; }\r\n.order-item { display:flex; justify-content:space-between; align-items:center; padding:16px 18px 14px; border-bottom:1px solid var(--color-border); }\r\n.order-item:last-child { border-bottom:none; }\r\n.order-info h4 { margin:0 0 6px; font-size:.95rem; font-weight:600; letter-spacing:.4px; color:var(--color-text); }\r\n.order-info p { margin:2px 0; font-size:.7rem; color:var(--color-text-sec); letter-spacing:.3px; }\r\n.order-price { color:var(--color-danger)!important; font-weight:700; letter-spacing:.4px; }\r\n.order-status { padding:6px 12px; border-radius:20px; font-size:.6rem; letter-spacing:1px; font-weight:700; text-transform:uppercase; box-shadow:0 2px 4px -2px rgba(0,0,0,.12); min-height:24px; display:flex; align-items:center; }\r\n.status-pending { background:#fff7d6; color:#856404; }\r\n.status-completed { background:#e6fbeb; color:#157347; }\r\n.status-cancelled { background:#fde7ea; color:#b02a37; }\r\n\r\n.view-all-orders { display:block; text-align:center; color:var(--color-primary); text-decoration:none; padding:12px 16px; background:var(--color-surface); border-radius:16px; font-size:.8rem; font-weight:600; border:1px solid var(--color-border); margin:6px 0 14px; transition:var(--transition-fast); }\r\n.view-all-orders:hover { background:var(--color-surface-alt); }\r\n\r\n@media (max-width: 640px) {\r\n  .user-info-card {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 24px 20px;\r\n  }\r\n\r\n  .user-avatar { margin: 0 0 20px; }\r\n\r\n  .edit-btn {\r\n    margin-top: 12px;\r\n    min-height: 44px;\r\n    padding: 12px 20px;\r\n  }\r\n\r\n  .menu-item {\r\n    padding: 18px 20px;\r\n    min-height: 56px;\r\n  }\r\n\r\n  .order-item {\r\n    padding: 16px 18px 14px;\r\n  }\r\n}\r\n\r\n/* 小屏幕优化 (≤480px) */\r\n@media (max-width: 480px) {\r\n  .profile-page {\r\n    padding-bottom: 20px; /* 移除底部导航栏空间，个人资料页面不显示导航栏 */\r\n  }\r\n\r\n  .user-info-card {\r\n    padding: 20px 16px;\r\n    margin: 16px 0 20px;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .user-avatar {\r\n    width: 60px;\r\n    height: 60px;\r\n    font-size: 48px;\r\n  }\r\n\r\n  .user-details h2 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .user-details p {\r\n    font-size: 0.75rem;\r\n  }\r\n\r\n  .menu-section {\r\n    margin: 20px 0 8px;\r\n  }\r\n\r\n  .menu-section h3 {\r\n    font-size: 0.95rem;\r\n    margin-bottom: 12px;\r\n  }\r\n\r\n  .menu-list {\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .menu-item {\r\n    padding: 16px 18px;\r\n    min-height: 52px;\r\n  }\r\n\r\n  .orders-section {\r\n    margin: 24px 0 8px;\r\n  }\r\n\r\n  .orders-section h3 {\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n  .orders-list {\r\n    border-radius: 20px;\r\n    padding: 8px 2px 2px;\r\n  }\r\n\r\n  .order-item {\r\n    padding: 14px 16px 12px;\r\n  }\r\n\r\n  .order-info h4 {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .order-info p {\r\n    font-size: 0.65rem;\r\n  }\r\n\r\n  .order-status {\r\n    font-size: 0.55rem;\r\n    padding: 4px 10px;\r\n    min-height: 20px;\r\n  }\r\n\r\n  .view-all-orders {\r\n    padding: 10px 14px;\r\n    font-size: 0.75rem;\r\n    border-radius: 14px;\r\n  }\r\n}\r\n\r\n/* 超小屏幕优化 (≤360px) */\r\n@media (max-width: 360px) {\r\n  .user-info-card {\r\n    padding: 18px 14px;\r\n    margin: 14px 0 18px;\r\n  }\r\n\r\n  .user-avatar {\r\n    width: 56px;\r\n    height: 56px;\r\n    font-size: 44px;\r\n  }\r\n\r\n  .user-details h2 {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .user-details p {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .edit-btn {\r\n    padding: 10px 16px;\r\n    font-size: 0.75rem;\r\n    min-height: 40px;\r\n  }\r\n\r\n  .menu-item {\r\n    padding: 14px 16px;\r\n    min-height: 48px;\r\n  }\r\n\r\n  .order-item {\r\n    padding: 12px 14px 10px;\r\n  }\r\n\r\n  .order-info h4 {\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .order-info p {\r\n    font-size: 0.6rem;\r\n  }\r\n\r\n  .order-status {\r\n    font-size: 0.5rem;\r\n    padding: 3px 8px;\r\n    min-height: 18px;\r\n  }\r\n}\r\n\r\n/* 极小屏幕优化 (≤320px) */\r\n@media (max-width: 320px) {\r\n  .user-info-card {\r\n    padding: 16px 12px;\r\n  }\r\n\r\n  .user-avatar {\r\n    width: 52px;\r\n    height: 52px;\r\n    font-size: 40px;\r\n  }\r\n\r\n  .user-details h2 {\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n  .edit-btn {\r\n    padding: 8px 14px;\r\n    font-size: 0.7rem;\r\n    min-height: 36px;\r\n  }\r\n\r\n  .menu-item {\r\n    padding: 12px 14px;\r\n    min-height: 44px;\r\n  }\r\n\r\n  .order-item {\r\n    padding: 10px 12px 8px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
